module.exports = __webpack_public_path__ + "img/scenes_16.74a9d2b4.png";